import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import store from "./store";
import { Provider } from "react-redux";
import { SidebarProvider } from "./context/SidebarContext";
import AppErrorBoundary from "./components/Common/ErrorBoundary/AppErrorBoundary";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  /**
   * React StrictMode has been temporarily disabled until the migration from Material UI v4 to the latest version is complete and remove materialize css.
   */
  // <React.StrictMode>
    <Provider store={store}>
      <AppErrorBoundary>
        <SidebarProvider>
          <App />
        </SidebarProvider>
      </AppErrorBoundary>
    </Provider>
  // </React.StrictMode>,
);
